// extracted by mini-css-extract-plugin
export default {"tx":"_99433095b9","line":"_4db7fecc6d"};